// src/pages/PrivacyPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
    return (
        <div className="privacy-page">
            <div className="container">
                <h1>Privacy</h1>
                <h2>Your rights under the California Consumer Privacy Act</h2>

                <p>
                    The California Consumer Privacy Act (CCPA) provides you with rights regarding how your data or personal information is treated.
                    Under the legislation, California residents can choose to opt out of the “sale” of their personal information to third parties.
                    Based on the CCPA definition, “sale” refers to data collection for the purpose of creating advertising and other communications.
                    <a href="https://oag.ca.gov/privacy/ccpa" target="_blank" rel="noopener noreferrer">
                        Learn more about CCPA and your privacy rights
                    </a>.
                </p>

                <h3>How to opt out</h3>
                <p>
                    By clicking on the link below, we will no longer collect or sell your personal information.
                    This applies to both third-parties and the data we collect to help personalize your experience on our website or through other communications.
                    For more information, view our <Link to="/privacy">privacy policy</Link>.
                </p>

                <p className="california-note">
                    To be eligible to opt-out, you must be browsing from California.
                </p>
            </div> 
        </div>
    );
};

export default PrivacyPage;